<template>
  <div class="wrp">
    <CreateLead_Check v-if="checkDisplay" :tutorChatToken="tutorChatToken"></CreateLead_Check>
    <CreateLead_Bind v-if="bindDisplay" :tutorChatToken="tutorChatToken"></CreateLead_Bind>
    <div v-if="leadRepeatDisplay" style="text-align:center;" id="nomalInfoContainer">
      <div>行動電話或Email重覆，無法新增。</div>
      <b-button variant="danger" @click="backToCheck()">上一步</b-button>
    </div>
    <CreateLead v-if="createDisplay" :tutorChatToken="tutorChatToken"></CreateLead>
  </div>
</template>

<script>
import CreateLead_Check from "../components/Main/CreateLead_Check.vue";
import CreateLead_Bind from "../components/Main/CreateLead_Bind";
import CreateLead from "../components/Main/CreateLead";
import store from "@/vuex/store_lead.js";

export default {
  name: "CreateLeadView",
  components: {
    CreateLead_Check,
    CreateLead_Bind,
    CreateLead
  },
  data() {
    return {
      tutorChatToken: ""
    };
  },
  created() {
    document.title = "新增名單";
    this.tutorChatToken = this.$route.query.tct;
  },
  methods: {
    backToCheck: function() {
      store.dispatch("setDisplayToDefult");
    }
  },
  computed: {
    createDisplay() {
      return store.state.createDisplay;
    },
    bindDisplay() {
      return store.state.bindDisplay;
    },
    leadRepeatDisplay() {
      return store.state.leadRepeatDisplay;
    },
    checkDisplay() {
      return store.state.checkDisplay;
    }
  }
};
</script>
<style scoped>
#nomalInfoContainer {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px;
}
.btn {
  font-size: 15px;
  background: #b20404;
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/MobileCreateLeadView.vue